export const getUsername = (isMobileLogin: boolean, mobile?: string, email?: string): string => {
  if (isMobileLogin) {
    return mobile ?? ''
  }
  return email ?? ''
}
